import { useState, useEffect } from 'react';

type ToggleSwitchProps = {
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (enabled: boolean) => void;
};

import clsx from "clsx";

export const ToggleSwitch = ({
  defaultChecked = false,
  checked,
  onChange,
}: ToggleSwitchProps) => {
  const [enabled, setEnabled] = useState<boolean>(
    checked ?? defaultChecked
  );

  useEffect(() => {
    if (checked !== undefined) {
      setEnabled(checked);
    }
  }, [checked]);

  const handleToggle = () => {
    const newValue = !enabled;
    setEnabled(newValue);
    onChange?.(newValue);
  };

  return (
    <div
      onClick={handleToggle}
      className={clsx(
        "w-12.5 h-7 rounded-full flex items-center p-0.5 cursor-pointer transition-colors duration-300",
        enabled
          ? "bg-[var(--color-primary-1)]/40"
          : "bg-gray-300"
      )}
    >
      <div
        className={clsx(
          "w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300",
          enabled
            ? "bg-[var(--color-primary-1)] translate-x-5.5"
            : "bg-gray-400 translate-x-0"
        )}
      >
        <svg
          viewBox="0 0 24 24"
          className="w-4 h-4 fill-white"
        >
          <path d="M9 16.2l-3.5-3.5-1.4 1.4L9 19 20 8l-1.4-1.4z" />
        </svg>
      </div>
    </div>
  );
};

// TODO: Fecha 260219: Eliminar codigo sobrante al terminar de migrar a Tailwind
/* 
const SwitchContainer = styled.div<{ $enabled: boolean }>`
  width: 50px;
  height: 28px;
  border-radius: 999px;
  background-color: ${({ $enabled }) => ($enabled ? '#a4ccb6' : '#ccc')};
  display: flex;
  align-items: center;
  padding: 2px;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const SwitchThumb = styled.div<{ $enabled: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ $enabled }) => ($enabled ? '#4caf50' : '#888')};
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ $enabled }) => ($enabled ? 'translateX(22px)' : 'translateX(0)')};
  transition: transform 0.3s ease, background-color 0.3s ease;
`;

const Checkmark = styled.svg`
  fill: white;
  width: 16px;
  height: 16px;
`;

export const ToggleSwitch = ({ defaultChecked = false, checked, onChange }: ToggleSwitchProps) => {
  const [enabled, setEnabled] = useState<boolean>(checked ?? defaultChecked);

  useEffect(() => {
    if (checked !== undefined) {
      setEnabled(checked);
    }
  }, [checked]);

  const handleToggle = () => {
    const newValue = !enabled;
    setEnabled(newValue);
    onChange?.(newValue);
  };

  return (
    <SwitchContainer onClick={handleToggle} $enabled={enabled}>
      <SwitchThumb $enabled={enabled}>
        <Checkmark viewBox="0 0 24 24">
          <path d="M9 16.2l-3.5-3.5-1.4 1.4L9 19 20 8l-1.4-1.4z" />
        </Checkmark>
      </SwitchThumb>
    </SwitchContainer>
  );
};
 */
